import $http from "@/plugins/axios";

class AgentSuggestionService {
    async agentAction(botCode, data) {
        return $http.post(`/live-support/agent-suggestion/agent-action/${botCode}`, data)
    }
    fetchSuggestion(botCode, data) {
        return $http.post(`/live-support/agent-suggestion/fetch-suggestion/${botCode}`, data)
    }
}
export default new AgentSuggestionService()